import { useMutation } from "@tanstack/react-query";
import {
  createRedemptionTransaction,
  deleteRedemptionTransactionApi,
  updateRedemptionTransactionApi,
} from "../../api/transaction/redemption";
import { useInvalidateTransactionOrder } from "./transaction";

export const useCreateRedemptionTransaction = (
  investmentAccountGuid: string
) => {
  const { invalidate } = useInvalidateTransactionOrder(investmentAccountGuid);

  return useMutation({
    mutationKey: ["transaction/redemption/create"],
    mutationFn: createRedemptionTransaction,
    onSuccess: invalidate,
  });
};

export const useUpdateRedemptionTransaction = (
  investmentAccountGuid: string
) => {
  const { invalidate } = useInvalidateTransactionOrder(investmentAccountGuid);

  return useMutation({
    mutationKey: ["transaction/redemption/update"],
    mutationFn: updateRedemptionTransactionApi,
    onSuccess: invalidate,
  });
};

export const useDeleteRedemptionTransaction = (
  investmentAccountGuid: string
) => {
  const { invalidate } = useInvalidateTransactionOrder(investmentAccountGuid);

  return useMutation({
    mutationKey: ["transaction/redemption/delete"],
    mutationFn: deleteRedemptionTransactionApi,
    onSuccess: invalidate,
  });
};
